import React, { Component } from "react";
import AuthService from "../../../../services/login/auth.service"
import history from "../../login/history";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import Popup from "react-popup";
import DatosSocio from "../../../generico/DatosSocio";
import SolicitarPinTransaccionalService from "../../../../services/autogestion/SolicitarPinTransaccionalService";
import { trackPromise } from "react-promise-tracker";

import ConfigService from "../../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import axios from 'axios'
import { oauth } from "../../../../components/generico/utils/UrlAPI";

export default class Paso1SolicitudPinTransaccional extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
    this.aceptarTerminos = this.aceptarTerminos.bind(this);
  }
  getInitialState = () => ({
    idContrato: undefined,
    mensaje: undefined,
    contratoFirmado: false,
  });
  resetState = () => {
    this.setState(this.getInitialState());
  };

  initData = () => {
    this.resetState();
    this.verificaTienePin();
  };
  componentDidMount() {
    this.initData();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              //history.push("/resumenGeneralSocio");
              history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
              window.location.reload();
              Popup.close();
            },
          },
        ],
      },
    });

  
    notifiPopupSolicitar = (titulo, mensaje) =>
    Popup.register({
        title: titulo,
        content: mensaje,
        buttons: {
            right: [
                {
                    text: "Aceptar",
                    className: "success",
                    action: () => {
                        this.solicitarPin();
                        this.logout();
                        Popup.close();

                    },
                },
                {
                    text: "Cerrar",
                    className: "secundary",
                    action: function () {
                        Popup.close();
                    },
                }
            ],
        },
    });


    avisoSolicitar = () => {
      var titulo = "INFO";
      var mensaje = "¿Estás seguro de realizar esta operación?"
      Popup.queue(
          this.notifiPopupSolicitar(titulo, mensaje)
      );
  }


  verificaTienePin() {
    trackPromise(
      AuthService.verificaTienePin().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        // codigo = 0  ya tiene pin activo
        // codigo = 1  ya tiene un pin con estado solicitado
        // codigo = 2  ya tiene un pin con estado rechazado
        // codigo = 3  ya tiene un pin con estado temporal
        // codigo = 4  no tiene pin

        if (jData.codigo === 4) {
          this.obtenerterminosCondiciones();
        } else {
          this.setState({
            mensaje: jData.mensaje,
          });
        }
      })
    );
  }

  getCurrentToken() {

    if (sessionStorage.getItem("user") === null)
      return "";

    var token = JSON.parse(sessionStorage.getItem("user"));
    return token.access_token;
  }
  async logout() {
    sessionStorage.removeItem("mostrarAviso");
    var config = {
      method: "post",
      url: oauth + "oauth/revoke-token",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getCurrentToken(),
      },

    };

    return axios(config).then((response) => {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("socio");
      sessionStorage.removeItem("cambio");
      sessionStorage.removeItem("cedula");
      sessionStorage.removeItem("temporal");
      sessionStorage.removeItem("temporal");
      sessionStorage.removeItem("AH");
      sessionStorage.removeItem("tipo");
      sessionStorage.removeItem("resumen");
      sessionStorage.removeItem("deuda");
      sessionStorage.clear();
      history.push("/");
      window.location.reload();
    });

  }
   
  solicitarPin() {
   
      trackPromise(
        SolicitarPinTransaccionalService.solicitarPin().then(
          (response) => {
            var data = JSON.stringify(response.data);
            var jData = JSON.parse(data);
            //console.log(jData);
            if (jData.codigoRetorno === "0") {
              mensajeExito("Datos actualizados");
            } else {
              this.continuar.disabled = true;
              Popup.queue(this.notifiPopup("Info", jData.mensajeRetorno));
            }
          }
        )
      );
  }


  obtenerterminosCondiciones() {
    trackPromise(
      SolicitarPinTransaccionalService.obtenerterminosCondiciones().then(
        (response) => {
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);
          if (jData.codigo === 0) {
            this.setState({
              mensaje: jData.datos.texto,
              idContrato: jData.datos.id,
            });
          } else {
            this.setState({
              mensaje:
                "El contrato ya fue aceptado. En el paso siguiente podrá cargar el PIN transaccional",
              contratoFirmado: true,
            });
          }
        }
      )
    );
  }

  aceptarTerminos() {
    var idContrato = this.state.idContrato;

    trackPromise(
      SolicitarPinTransaccionalService.aceptarTerminos(idContrato).then(
        (response) => {
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);
          //console.log(jData);
          if (jData.codigo === 0) {
            this.nextStep.click();
          }
        }
      )
    );
  }

  render() {
    return (
      <div>
       


        <div className="col-md-12">
          <div className="row justify-content-md-center">
            <div className="col-md-8">
              <DatosSocio />
            </div>
          </div>
          <br />
          <div className="row justify-content-md-center">
            <div className="col-md-8">
              <MensajeUsuario tipo="INFO"
                titulo="Importante"
                mensaje=" En el caso de no poseer u olvidar el pin transaccional puede utilizar esta opción. La misma generá un pin temporal que será enviada vía SMS. En el caso de aceptar la operación, cerrará sesión para configurar el nuevo pin transaccional." />
              {this.state.message && (
                <MensajeUsuario tipo="ERROR"
                  titulo="Importante."
                  mensaje={this.state.mensaje} />
              )}
            </div>
          </div>

          <hr />

          <div className="row float-right">
            <div className="col-md-12">
             
              
              
                  <button
                    type="submit"
                    className="btn btn-cu-primary"
                    onClick={() => {
                      this.avisoSolicitar();

                    }}
                  >
                   <FontAwesomeIcon icon={faCheck}  />Confirmar
                  </button>
                

              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
